import { useEffect, useRef, useState } from 'react';

import { useParams } from 'react-router-dom/cjs/react-router-dom';
import moment from 'moment/moment';

import { Company, } from '../../classess/company/company';
import { Customer, } from '../../classess/customer/customer';
import { SystemAccess, } from '../../classess/systemAccess/systemAccess';
import { Status, } from '../../classess/status/status';
import { Type, } from '../../classess/type/type';
import { GlobalFormats } from '../../classess/main/globalFormats';

import {
    awaitDelayAsync, badgetStatusGeneric, getProcessButtons, charactersRemainingGet, dataTableLanguaje, setDateTimeFormatGlobalString, getDtRowIndex, isUndNull, isUndNullEmp, isValidDate,
    getLanguageObj, lodash, getResponse, getRolesType, settings, styles, getUserRoles, LoadingSection, handleResponseMessageAsync
} from '../../helpers/main';
import { SystemAccessService } from '../../services/systemAccesses/SystemAccessService';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import parse from 'html-react-parser';
import { SystemAccessDetail } from '../../classess/systemAccess/systemAccessDetail';
import { User } from '../../classess/user/user';
import SystemAccessDetailAddEditDetail from './SystemAccessDetailAddEditDetail';
import Swal from 'sweetalert2';
import AccessDenied from '../main/AccessDenied';
import TableIndex from '../main/TableIndex';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, icons, html, images, labels, messages, timers } = settings;

const currentMethod = 'SystemAccessAddEditDetails';

export default function SystemAccessAddEditDetails({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const { type = '', id = 0 } = useParams();
    const [viewParams] = useState({
        type: type === labels?.edit?.en?.toLowerCase() ? 1 :
            (type === labels?.details?.en?.toLowerCase() ? 2 :
                (type === labels?.create?.en?.toLowerCase() ? 0 : -1)),
        id: parseInt(id),
    });

    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    let userRoles = getRolesType();
    userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;
    const [types, setTypes] = useState([]);
    const [admins, setAdmins] = useState([]);
    const [users, setUsers] = useState([]);
    const [status, setStatus] = useState([]);
    const [analysts, setAnalysts] = useState([]);
    const [companies, setCompanies] = useState([]);
    const [companiesSel, setCompaniesSel] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [customersSel, setCustomersSel] = useState([]);
    const [usersCustomer, setUsersCustomer] = useState([]);
    const [usersCustomerSel, setUsersCustomerSel] = useState([]);
    const [userCompanyCustomers, setUserCompanyCustomers] = useState([]);
    const [systemAccess, setSystemAccess] = useState(SystemAccess?.class({}, false));
    const [systemAccessBefore, setSystemAccessBefore] = useState(SystemAccess?.class({}, false));

    const isMount = useRef(false);
    const btnProcessDetailsRef = useRef(null);
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ save: false, edit: false, report: false, addDetail: false, showLoading: true });

    const dtSystemAccessesDetailsId = 'dtSystemAccessesDetails';
    const controls = {
        buttons: {
            addDetail: {
                defaultClass: 'btn btn-info shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddDetails',
            },
            back: {
                defaultClass: 'btn btn-light border shadow-sm font-weight-bold mx-1 px-4 text-secondary',
                id: 'btnBack',
            },
            edit: {
                defaultClass: 'btn btn-warning shadow-sm font-weight-bold mx-1 px-4 text-dark',
                id: 'btnEdit',
            },
            processDetails: {
                defaultClass: 'btn btn-warning shadow-sm font-weight-bold mx-1 px-4 text-dark',
                id: 'btnProcessDetails',
            },
            report: {
                defaultClass: 'btn btn-secondary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnReport',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnSave',
            },
        },
        checkBoxs: {
            backupReviews: {
                id: 'chkBackupReviews',
                defaultClass: '',
            },
            billToPay: {
                id: 'chkBillToPay',
                defaultClass: '',
            },
            dataCenter: {
                id: 'chkDataCenter',
                defaultClass: '',
            },
            domainHosting: {
                id: 'chkDomainHosting',
                defaultClass: '',
            },
            legendEnabled: {
                id: 'chkLegendEnabled',
                defaultClass: '',
            },
            legendDisabled: {
                id: 'chkLegendDisabled',
                defaultClass: '',
            },
            parameters: {
                id: 'chkParameters',
                defaultClass: '',
            },
            paymentInformation: {
                id: 'chkPaymentInformation',
                defaultClass: '',
            },
            purchase: {
                id: 'chkPurchase',
                defaultClass: '',
            },
            requirements: {
                id: 'chkRequirements',
                defaultClass: '',
            },
            remoteConnectionsDNS: {
                id: 'chkRemoteConnectionsDNS',
                defaultClass: '',
            },
            systemAccess: {
                id: 'chkSystemAccess',
                defaultClass: '',
            },
            userInformCreation: {
                id: 'chkUsersInformCreation',
                defaultClass: '',
            },
            userInformCreationDetail: {
                id: 'chkUsersInformCreationDetail',
                defaultClass: '',
            },
            userInformCompletionDetail: {
                id: 'chkUsersInformCompletionDetail',
                defaultClass: '',
            },
            userInformCompletionBefore: {
                id: 'chkUsersInformCompletionBefore',
                defaultClass: '',
            },

        },
        dataTables: {
            systemAccessesDetails: {
                buttons: {
                    process: {
                        id: 5,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtSystemAccessesDetailsId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtSystemAccessesDetailsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtSystemAccessesDetailsId}_paginate`,
                        defaultClass: '',
                    }
                }
            },
        },
        icons: {
            addDetail: {
                id: 'iconaddDetail',
                defaultClass: icons?.tasksFasFa,
            },
            back: {
                id: 'iconBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
            edit: {
                id: 'iconEdit',
                defaultClass: icons?.fasFa?.edit,
            },
            processDetails: {
                id: 'iconProcessDetails',
                defaultClass: icons?.fasFa?.cogs,
            },
            report: {
                id: 'iconReport',
                defaultClass: icons?.fasFa?.fileAlt,
            },
            save: {
                id: 'iconSave',
                defaultClass: icons?.fasFa?.save,
            },
        },
        inputs: {
            id: {
                id: 'inputId',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            userRegisterDate: {
                id: 'inputUserRegisterDate',
                defaultClass: 'form-control datetimepicker-input bg-light border-0 shadow-sm text-dark',
                //defaultClass: 'form-control text-black bg-transparent datetimepicker-input',
            },
        },
        pickers: {
            userRegisterDate: {
                id: 'pkUserRegisterDate',
            },
        },
        selects: {
            analysts: {
                id: 'selAnalysts',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            company: {
                id: 'selCompany',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            customer: {
                id: 'selCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            status: {
                id: 'selStatus',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            types: {
                id: 'selTypes',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            usersCustomer: {
                id: 'selUsersCustomer',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
            userInformCreation: {
                id: 'selUserInformCreation',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
        },
        textAreas: {
            commentary: {
                id: 'textAreaCommentary',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            addDetail: {
                id: 'spAddDetail',
                defaultClass: '',
            },
            back: {
                id: 'spBack',
                defaultClass: '',
            },
            edit: {
                id: 'spEdit',
                defaultClass: '',
            },
            processDetails: {
                id: 'spProcessDetails',
                defaultClass: '',
            },
            report: {
                id: 'spReport',
                defaultClass: '',
            },
            save: {
                id: 'spSave',
                defaultClass: '',
            },
        },
    };
    const componentUrls = {
        back: `${backend?.urls?.systemAccesses}/`,
        details: `${backend?.urls?.systemAccesses}/${labels?.details?.en?.toLowerCase()}/`,
        edit: `${backend?.urls?.systemAccesses}/${labels?.edit?.en?.toLowerCase()}/`,
    };

    const [dataFormLength] = useState(SystemAccess?.minMaxLength(false));
    const [controlsStatus_, setControlsStatus_] = useState({ customer: false, userCustomer: false, userInformCreation: false, });
    const [errors, setErrors] = useState({ company: '', customer: '', userCustomer: '', type: '', commentary: '', analyst: '', status: '', userRegisterDate: '', userInformCreation: '' });
    const [charactersRemaining, setCharactersRemaining] = useState('');
    const [statusObj, setStatusObj] = useState({
        finalized: {
            label: labels?.finalized?.en,
            model: Status?.getClass({}, false),
        },
    });
    let saFieldViewsObj = {
        company: {
            model: Company?.getClass({}, false),
            html: '',
        },
        customer: {
            model: Customer?.getClass({}, false),
            html: '',
        },
        commentary: '',
        model: SystemAccess?.class({}, false),
        informCompletion: {
            html: '',
            status: false,
            date: '',
            time: '',
        },
        informCreation: {
            html: '',
            status: false,
            date: '',
            time: '',
            user: {
                model: User?.getClass({}, false),
                html: ''
            },
        },
        register: {
            date: '',
            time: '',
            html: '',
        },
        analyst: {
            model: User?.getClass({}, false),
            html: ''
        },
        status: {
            model: Status?.getClass({}, false),
            label: '',
            html: '',
        },
        type: {
            model: Type?.class({}, false),
            label: '',
            html: ''
        },
        user: {
            model: User?.getClass({}, false),
            html: ''
        },

    };
    const [saFieldViews, setSaFieldViews] = useState(saFieldViewsObj);
    let sadFieldViewsObj = {
        register: {
            date: '',
            time: '',
        },
        analyst: {
            model: User?.getClass({}, false),
            html: ''
        },
        commentary: '',
        userRegister: {
            model: User?.getClass({}, false),
            html: ''
        },
        userRegisterDate: {
            date: '',
            time: '',
        },
    };
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        dtSystemAccessesDetailsId: dtSystemAccessesDetailsId,
        dtSystemAccessesDetailsRowId: 0,
        sadFieldViews: sadFieldViewsObj,
        systemAccessDetail: SystemAccessDetail?.class({}, false),
        analysts: [User?.getClass({}, false)],
        adminAnalysts: [User?.getClass({}, false)],
        status: [Status?.getClass({}, false)],
        viewParams: viewParams,
        userRoles: userRoles,
    });
    const [systemAccessDetailObj, setSystemAccessDetailObj] = useState({ id: 0, description: '', rowid: 0, processType: 0, subMethod: '', });
    //#endregion variables

    //#region methods
    //#region systemaccess
    const addSystemAccess = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'addSystemAccess';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let systemAccessData = SystemAccess?.class({}, false);
            //#endregion variables

            e?.preventDefault?.();

            if (systemAccess?.statusId === statusObj?.finalized?.model?.id &&
                systemAccessBefore?.statusId === statusObj?.finalized?.model?.id) {
                return;
            }

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region systemaccess (add)
            response = await SystemAccessService.create({
                auth,
                systemAccess,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            systemAccessData = response?.result?.systemAccess || {};
            setSystemAccess(systemAccessData);
            //#endregion systemaccess (add)

            response = getResponse({
                type: 0,
                msgText: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`,
                urlGoTo: (userRoles?.isAdmin || userRoles?.isAnalyst) ?
                    `${componentUrls?.edit}${systemAccessData?.id}` :
                    `${componentUrls?.details}${systemAccessData?.id}`,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const editSystemAccess = async ({
        e = {},
        subMethod = ''
    } = {}) => {
        const currentMethod = 'editSystemAccess';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let typesData = [];
            let adminsData = [];
            let statusData = [];
            let analystsData = [];
            let companiesData = [];
            let customersData = [];
            let customerUsersData = [];
            let systemAccessData = SystemAccess?.class({}, false);
            let systemAccessDetailsData = [SystemAccessDetail?.class({}, false)];
            let userCompanyCustomersData = [];
            //#endregion variables

            e?.preventDefault?.();

            if (systemAccess?.statusId === statusObj?.finalized?.model?.id &&
                systemAccessBefore?.statusId === statusObj?.finalized?.model?.id) {
                return;
            }

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = setData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region systemaccess (update)
            response = await SystemAccessService.update({
                auth,
                systemAccess,
                languageId: languageObj?.id,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning) return;

            //#region systemaccess (set data)
            adminsData = response?.result?.admins || [];
            adminsData?.sort((a, b) => a.name > b.name ? 1 : -1);
            setAdmins(adminsData);

            companiesData = response?.result?.companies || [];
            companiesData?.sort((a, b) => a.name > b.name ? 1 : -1);
            setCompanies(companiesData);

            customersData = response?.result?.customers || [];
            customersData?.sort((a, b) => a.name > b.name ? 1 : -1);
            setCustomers(customersData);

            statusData = response?.result?.status || [];

            typesData = response?.result?.types || [];

            analystsData = response?.result?.analysts || [];
            analystsData = analystsData?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
            setAnalysts(analystsData);

            customerUsersData = response?.result?.usersCustomer || [];
            customerUsersData = customerUsersData?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
            setUsersCustomer(customerUsersData);

            userCompanyCustomersData = response?.result?.userCompanyCustomers || [];
            setUserCompanyCustomers(userCompanyCustomersData);

            systemAccessData = response?.result?.systemAccess || {};
            systemAccessData.registerDate = isUndNullEmp({ data: systemAccessData?.registerDate, subMethod: currentMethod })?.result ?
                moment(new Date())?.format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}`) : systemAccessData.registerDate;
            systemAccessData.userRegisterDate = isUndNullEmp({ data: systemAccessData?.userRegisterDate, subMethod: currentMethod })?.result ?
                moment(new Date())?.format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}`) : systemAccessData.userRegisterDate;
            setSystemAccess(systemAccessData);
            setSystemAccessBefore(systemAccessData);
            systemAccessDetailsData = response?.result?.systemAccessDetails || [];
            //#endregion systemaccess (set data)
            //#endregion systemaccess (update)

            //setControlsStatus({ processType: 0, subMethod: currentMethod, });

            //#region selects (set data)
            response = await dataGeneralSetAsync({
                //processType: viewParams?.type > 0 ? 4 : viewParams?.type,
                processType: 4,
                companyId: systemAccessData?.companyId || -1,
                customerId: systemAccessData?.customerId || -1,
                userId: systemAccessData?.userId || '',
                _systemAccess: systemAccessData || {},
                _admins: adminsData,
                _analysts: analystsData,
                _companies: companiesData,
                _customers: customersData,
                _customerUsers: customerUsersData || [],
                _userCompanyCustomers: userCompanyCustomersData,
                _status: statusData,
                _types: typesData,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion selects (set data)

            //#region set characters remainig
            setCharactersRemaining(
                charactersRemainingGet({
                    text: systemAccessData?.commentary,
                    maxLength: dataFormLength?.max?.commentary,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set characters remainig

            //#region set data input timers
            response = await setDateInControl({
                _date: new Date().toISOString(),
                _userRegisterDate: systemAccessData?.userRegisterDate,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion set data input timers

            //#region datatable (set data)
            if (!isUndNullEmp({ data: systemAccessDetailsData, subMethod: currentMethod, })?.result &&
                systemAccessDetailsData?.length > 0) {
                $(`#${dtSystemAccessesDetailsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
                response = setDataInDataTable({
                    data: systemAccessDetailsData,
                    systemAccess: systemAccessData,
                    analysts: analystsData,
                    status: statusData,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
            }
            //#endregion datatable (set data)

            response = getResponse({
                type: 0,
                msgText: `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`,
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, save: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getReportSystemAccess = async ({
        e = {}, subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getReportSystemAccess';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({ ...prev, report: true, showLoading: true }));

            //#region get data (requirement report)
            response = await SystemAccessService.getReport({
                auth,
                id: systemAccess?.id || 0,
                languageCode: languageObj?.code,
                subMethod: currentMethod
            });

            if (!response?.isSuccess || response?.isWarning)
                return;
            //#endregion get data (requirement report)

            window.open(response?.result, '_blank', 'noopener,noreferrer');
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, report: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion systemaccess

    //#region systemaccess (details)
    const getSystemAccessDetailAddDetailEditPrev = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        processType = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getSystemAccessDetailAddDetailEditPrev';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region check role
            if (processType !== 2 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`,
                });
                return;
            }
            //#endregion check role

            //#region set data
            setSystemAccessDetailObj({
                id: id,
                description: description,
                rowid: rowId,
                processType: processType,
                subMethod: subMethod,
            });
            //#endregion set data

            // $(`#${controls?.buttons?.processDetails?.id}`)?.trigger('click');
            btnProcessDetailsRef?.current?.click?.();
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const getSystemAccessDetailAddDetailEdit = async ({
        e = {},
        id = 0,
        description = '',
        rowId = 0,
        processType = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'getSystemAccessDetailAddDetailEdit';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            // let msgText = '';
            let adminAnalysts = [];
            let sadFieldViews = sadFieldViewsObj;
            let modelSystemAccessDetail = SystemAccessDetail?.class({}, false);
            //#endregion variables

            //#region btn process (get data)
            if (processType === 2014) {
                id = systemAccessDetailObj?.id || 0;
                description = systemAccessDetailObj?.description || '';
                rowId = systemAccessDetailObj?.rowid || 0;
                processType = systemAccessDetailObj?.processType || 0;
                subMethod = systemAccessDetailObj?.subMethod || '';
            }
            //#endregion btn process (get data)

            e?.preventDefault?.();

            //#region systemaccess (check status)
            if (processType !== 2) {
                if ((viewParams?.type !== 1) ||
                    (systemAccess?.statusId === statusObj?.finalized?.model?.id &&
                        systemAccessBefore?.statusId === statusObj?.finalized?.model?.id)) {
                    return;
                }
            }
            //#endregion systemaccess (check status)

            //#region check role
            if (processType !== 2 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`,
                });
                return;
            }
            //#endregion check role

            if (processType !== -1) {
                setProcess(prev => ({ ...prev, addDetail: processType === 0, showLoading: true }));
            }

            adminAnalysts = admins;
            adminAnalysts = adminAnalysts?.concat(analysts);
            adminAnalysts = adminAnalysts?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
            //#region systemaccessdetail (add)
            switch (processType) {
                case -1:
                    //#region show message
                    const msgTextObj = {
                        one: `${messages?.areYouShureDeleteThis?.[languageObj?.id]}`,
                        two: `${labels?.systemAccess?.[languageObj?.id]} (${labels?.detail?.[languageObj?.id]?.toLowerCase()}):<br/><b>${description}</b><br/>`,
                        three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
                    };
                    const swalProperties = {
                        icon: settings?.react?.sweetAlert2?.messages?.types?.warning,
                        title: msgTextObj?.one,
                        html: `${msgTextObj?.two}${msgTextObj?.three}`,
                        timer: null,
                        showConfirmButton: !Swal.isLoading(),
                        confirmButtonColor: settings?.colors?.warningColorExp,
                        confirmButtonText: labels?.yes?.[languageObj?.id],
                        showCancelButton: !Swal.isLoading(),
                        cancelButtonColor: settings?.colors?.successColorExp,
                        cancelButtonText: labels?.no?.[languageObj?.id],
                        showLoaderOnConfirm: true,
                        didOpen: () => {
                            Swal.hideLoading();
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                        preConfirm: async () => {
                            let preConfirmResponse = getResponse({ type: 0 });
                            try {
                                Swal.getCancelButton().hidden = true;
                                Swal.update({
                                    icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                                    title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                                    html: `${msgTextObj?.two}`,
                                    showConfirmButton: false,
                                });

                                //#region systemaccessdetail (delete)
                                preConfirmResponse = await SystemAccessService.deleteDetail({
                                    auth,
                                    id: id,
                                    languageId: languageObj?.id,
                                    subMethod: currentMethod
                                });

                                if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                                //#endregion systemaccessdetail (delete)

                                //#region delete datatable (systemaccessdetail)
                                $(`#${dtSystemAccessesDetailsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                                preConfirmResponse = getResponse({
                                    type: 0,
                                    msgText: messages?.processCompletedSuccessfully?.[languageObj?.id],
                                });
                                //#endregion delete datatable (systemaccessdetail)
                            } catch (ex) {
                                preConfirmResponse = getResponse({ type: -1 });
                                preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                                    preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                                }
                                preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                            }
                            return preConfirmResponse;
                        },
                    };

                    const swalResult = await Swal.fire({ ...swalProperties });
                    if (swalResult?.isConfirmed && swalResult?.value) {
                        response = swalResult?.value;
                    } else if (swalResult?.isDismissed) {
                        response = getResponse({ type: 0 });
                    }
                    //#endregion show message
                    break;
                case 0:
                    await awaitDelayAsync({ delayTime: timers?.oneSecond, });
                    setModalObj(prev => ({
                        ...prev,
                        adminAnalysts: adminAnalysts,
                        analysts: analysts,
                        systemAccessDetail: {
                            ...prev?.systemAccessDetail,
                            systemAccessId: systemAccess?.id,
                            userRegisterDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                            register: new Date()?.toISOString(),
                            registerDate: new Date()?.toISOString(),
                            informCreationUserId: auth?.user?.id,
                        },
                        showModal: true,
                        status: status,
                    }));
                    break;
                default:
                    if (processType === 1 || processType === 2) {
                        //#region systemaccessdetail (get)
                        response = await SystemAccessService.getDetailById({
                            auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod
                        });

                        if (!response?.isSuccess || response?.isWarning) return;

                        setAdmins(response?.result?.admins || []);
                        setAnalysts(response?.result?.analysts || []);

                        adminAnalysts = response?.result?.admins || [];
                        adminAnalysts = adminAnalysts?.concat(response?.result?.analysts || []);
                        adminAnalysts = adminAnalysts?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);

                        //#region set fields
                        if (processType === 2) {
                            modelSystemAccessDetail = SystemAccessDetail?.class(response?.result?.systemAccessDetail, false);
                            sadFieldViews.analyst.model = analysts?.filter(({ id }) => id === modelSystemAccessDetail?.analystId)?.[0] || {};
                            sadFieldViews.analyst.html = `${sadFieldViews?.analyst?.model?.firstName || ''} ${sadFieldViews?.analyst?.model?.lastName || ''} - ${sadFieldViews?.analyst?.model?.department || ''}`
                            sadFieldViews.commentary = modelSystemAccessDetail?.commentary || '';
                            sadFieldViews.register.date = setDateTimeFormatGlobalString({
                                date: modelSystemAccessDetail?.registerDate,
                                dateFormat: languageObj?.format?.date?.f1,
                                timeFormat: 0,
                                withSeconds: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result;
                            sadFieldViews.register.time = setDateTimeFormatGlobalString({
                                date: modelSystemAccessDetail?.registerDate,
                                dateFormat: '',
                                timeFormat: languageObj?.format?.time?.type,
                                withSeconds: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result;
                            sadFieldViews.userRegister.model = adminAnalysts?.filter(({ id }) => id === modelSystemAccessDetail?.informCreationUserId)?.[0] || {};
                            sadFieldViews.userRegister.html = `${sadFieldViews?.userRegister?.model?.firstName || ''} ${sadFieldViews?.userRegister?.model?.lastName || ''} - ${sadFieldViews?.userRegister?.model?.department || ''}`
                            sadFieldViews.userRegisterDate.date = setDateTimeFormatGlobalString({
                                date: modelSystemAccessDetail?.userRegisterDate,
                                dateFormat: languageObj?.format?.date?.f1,
                                timeFormat: 0,
                                withSeconds: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result;
                            sadFieldViews.userRegisterDate.time = setDateTimeFormatGlobalString({
                                date: modelSystemAccessDetail?.userRegisterDate,
                                dateFormat: '',
                                timeFormat: languageObj?.format?.time?.type,
                                withSeconds: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            })?.result;
                        }
                        //#endregion set fields
                        setModalObj(prev => ({
                            ...prev,
                            adminAnalysts: adminAnalysts,
                            analysts: response?.result?.analysts,
                            dtSystemAccessesDetailsRowId: rowId,
                            type: processType,
                            sadFieldViews: sadFieldViews,
                            systemAccessDetail: response?.result?.systemAccessDetail || {},
                            showModal: true,
                            status: status,
                        }));
                        //#endregion systemaccessdetail (get)
                    }
                    break;
            }
            //#endregion systemaccessdetail (add)
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, addDetail: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }
    //#endregion systemaccess (details)

    //#region others
    const getData = async ({
        subMethod = ''
    }) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let typesData = [];
            let adminsData = [];
            let statusData = [];
            let analystsData = [];
            let companiesData = [];
            let customersData = [];
            let customerUsersData = [];
            let systemAccessData = SystemAccess?.class({}, false);
            let systemAccessDetailsData = SystemAccessDetail?.class({}, false);
            let userCompanyCustomersData = [];
            //#endregion variables

            //#region check type (url)
            if (viewParams?.type > 2 || viewParams?.type < 0) {
                window.location.href = `${backend?.urls?.notFound}`;
            } else if (viewParams?.type === 0 && viewParams?.id !== 0) {
                window.location.href = `${backend?.urls?.notFound}`;
            } else if (viewParams?.type > 0 && viewParams?.id === 0) {
                window.location.href = `${backend?.urls?.notFound}`;
            }
            //#endregion check type (url)

            if (!auth?.isLoged({ subMethod: currentMethod })?.result) {
                setShowData(false);
                response.urlGoTo = componentUrls?.back;
                return;
            }

            //#region datatable / querycode (set)
            if (viewParams?.type !== 0) {
                //#region datatable (set)
                response = setDataTables({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({ subMethod: currentMethod, });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code
            }
            //#endregion datatable / querycode (set)

            //#region check role
            if (viewParams?.type === 1 && !userRoles?.isAdmin && !userRoles?.isAnalyst) {
                response = getResponse({
                    type: 1,
                    msgText: `${messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageObj?.id]}.`,
                    urlGoTo: componentUrls?.back
                });
                return;
            }
            //#endregion check role

            //#region systemaccess (get data / add / edit / details)
            if (viewParams?.type === 0) {
                //#region add
                response = await SystemAccessService.getAdd({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });
                //#endregion add
            } else if (viewParams?.type > 0) {
                //#region edit / details
                response = await SystemAccessService.getById({
                    auth,
                    id: id,
                    withDetails: true,
                    languageId: languageObj?.id,
                    subMethod: currentMethod
                });
                //#endregion edit / details
            }

            if (!response?.isSuccess || response?.isWarning) return;

            adminsData = response?.result?.admins || [];
            adminsData?.sort((a, b) => a.name > b.name ? 1 : -1);
            setAdmins(adminsData);

            companiesData = response?.result?.companies || [];
            companiesData?.sort((a, b) => a.name > b.name ? 1 : -1);
            setCompanies(companiesData);

            customersData = response?.result?.customers || [];
            customersData?.sort((a, b) => a.name > b.name ? 1 : -1);
            setCustomers(customersData);

            statusData = response?.result?.status || [];
            setStatusObj({
                ...statusObj,
                finalized: {
                    ...statusObj?.finalized,
                    model: statusData?.filter(({ name, label, }) => label === statusObj?.finalized?.label || name === statusObj?.finalized?.label)?.[0] || {},
                },
            });

            typesData = response?.result?.types || [];

            analystsData = response?.result?.analysts || [];
            analystsData = analystsData?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
            setAnalysts(analystsData);

            customerUsersData = response?.result?.usersCustomer || [];
            customerUsersData = customerUsersData?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
            setUsersCustomer(customerUsersData);

            userCompanyCustomersData = response?.result?.userCompanyCustomers || [];
            setUserCompanyCustomers(userCompanyCustomersData);

            systemAccessData = response?.result?.systemAccess || {};

            //#region analyst / status / informcreationuserid / informcreation (set)
            if (!userRoles?.isAdmin && viewParams?.type === 0) {
                systemAccessData.statusId = statusData?.filter(({ name, }) => name === labels?.created?.en)?.[0]?.id || 0;
                systemAccessData.informCreationUserId = auth?.user?.id;
                systemAccessData.informCreation = true;
                if (userRoles?.isAnalyst) {
                    systemAccessData.analystId = auth?.user?.id;
                } else {
                    systemAccessData.analystId = analystsData?.[0]?.id || '';
                }
            }
            //#endregion analyst / status / informcreationuserid / informcreation (set)

            systemAccessData.registerDate = isUndNullEmp({ data: systemAccessData?.registerDate, subMethod: currentMethod })?.result ?
                moment(new Date())?.format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}`) : systemAccessData.registerDate;
            systemAccessData.userRegisterDate = isUndNullEmp({ data: systemAccessData?.userRegisterDate, subMethod: currentMethod })?.result ?
                moment(new Date())?.format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}`) : systemAccessData.userRegisterDate;
            systemAccessDetailsData = response?.result?.systemAccessDetails || [];
            setSystemAccess(systemAccessData);
            setSystemAccessBefore(systemAccessData);
            //#endregion systemaccess (get data / add / edit / details)

            //#region fields (set data)
            if (viewParams?.type === 2) {
                response = dataFieldsSet({
                    systemAccess: systemAccessData,
                    systemAccessDetails: systemAccessDetailsData,
                    admins: adminsData,
                    analysts: analystsData,
                    companies: companiesData,
                    customers: customersData,
                    customerUsers: customerUsersData,
                    status: statusData,
                    types: typesData,
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) {
                    response.urlGoTo = componentUrls?.back;
                    return
                }
            }
            //#endregion fields (set data)

            //#region selects (set data)
            response = await dataGeneralSetAsync({
                processType: viewParams?.type > 0 ? 4 : viewParams?.type,
                companyId: systemAccessData?.companyId || -1,
                customerId: systemAccessData?.customerId || -1,
                userId: systemAccessData?.userId || '',
                _systemAccess: systemAccessData || {},
                _admins: adminsData,
                _analysts: analystsData,
                _companies: companiesData,
                _customers: customersData,
                _customerUsers: customerUsersData || [],
                _userCompanyCustomers: userCompanyCustomersData,
                _status: statusData,
                _types: typesData,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion selects (set data)

            //#region set characters remainig
            setCharactersRemaining(
                charactersRemainingGet({
                    text: systemAccessData?.commentary,
                    maxLength: dataFormLength?.max?.commentary,
                    msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                    subMethod: currentMethod,
                })?.result
            );
            //#endregion set characters remainig

            //#region set data input timers
            response = await setDateInControl({
                _date: new Date().toISOString(),
                _userRegisterDate: systemAccessData?.userRegisterDate,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                response.urlGoTo = componentUrls?.back;
                return;
            }
            //#endregion set data input timers


            //#region dataintableset (set)
            if (viewParams?.type !== 0) {
                //#region set datatable
                if ((!isUndNullEmp({ data: systemAccessDetailsData, subMethod: currentMethod })?.result && systemAccessDetailsData?.length > 0)) {
                    response = setDataInDataTable({
                        data: systemAccessDetailsData,
                        systemAccess: systemAccessData,
                        analysts: analystsData,
                        status: statusData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            }
            //#endregion dataintableset (set)
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const dataGeneralSetAsync = async ({
        processType = 0,
        companyId = -1,
        customerId = -1,
        userId = '',
        _systemAccess = {},
        _admins = (admins?.length > 0) ? admins : [],
        _analysts = (analysts?.length > 0) ? analysts : [],
        _companies = (companies?.length > 0 ? companies : []),
        _customers = (customers?.length > 0 ? customers : []),
        _customerUsers = (usersCustomer?.length > 0 ? usersCustomer : []),
        _userCompanyCustomers = (userCompanyCustomers?.length > 0 ? userCompanyCustomers : []),
        _status = (status?.length > 0 ? status : []),
        _types = (types?.length > 0 ? types : []),
        showMsgError = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'dataGeneralSetAsync';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let arrayObj = {
                array: [],
                arrayValues: [],
            };
            //#endregion variables

            //#region process
            //Leyend
            //0 - Companies
            //1 - Customers
            //2 - UsersCustomer
            switch (processType) {
                case 0:
                    //#region companies
                    response = lodash?.unique({ data: _userCompanyCustomers, key: 'companyId', subMethod: currentMethod });
                    if (!response.isSuccess || response?.isWarning) return response;

                    arrayObj.array = response?.result;
                    arrayObj?.array?.forEach((ucc) => {
                        const company = _companies?.filter(({ id }) => id === ucc?.companyId)?.[0] || {};
                        if (!isUndNullEmp({ data: company, subMethod: currentMethod, })?.result) {
                            arrayObj.arrayValues.push(company);
                        }
                    });

                    arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.name > b?.name ? 1 : -1);
                    setCompaniesSel(arrayObj?.arrayValues);
                    //#endregion companies

                    //#region status
                    _status?.forEach((status) => {
                        const statusLabel = !isUndNullEmp({ data: status?.label, subMethod: currentMethod })?.result ?
                            status?.label :
                            `${status?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${status?.name?.replace(' ', '')?.slice(1)}`;
                        status.label = labels?.[statusLabel]?.[languageObj?.id];
                        //status.label = labels?.[statusLabel]?.['es'];
                    });
                    _status = _status?.sort((a, b) => a?.label > b?.label ? 1 : -1);
                    setStatus(_status);
                    //#endregion status

                    //#region types
                    _types?.forEach((type) => {
                        const typeLabel = !isUndNullEmp({ data: type?.label, subMethod: currentMethod })?.result ?
                            type?.label :
                            `${type?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${type?.name?.replace(' ', '')?.slice(1)}`;
                        type.label = labels?.[typeLabel]?.[languageObj?.id];
                        //type.label = labels?.[typeLabel]?.['es'];
                    });
                    _types = _types?.sort((a, b) => a?.label > b?.label ? 1 : -1);
                    setTypes(_types);
                    //#endregion types
                    break;
                case 1:
                    if (companyId !== -1) {
                        arrayObj.array = _userCompanyCustomers?.filter(({ companyId: ci }) => ci === companyId) || [];

                        response = lodash?.unique({ data: arrayObj.array, key: 'customerId', subMethod: currentMethod });
                        if (!response.isSuccess || response?.isWarning) return response;

                        arrayObj.array = response?.result;
                        arrayObj?.array?.forEach((ucc) => {
                            const customer = _customers?.filter(({ id }) => id === ucc?.customerId)?.[0] || {};
                            if (!isUndNullEmp({ data: customer, subMethod: currentMethod, })?.result) {
                                arrayObj.arrayValues.push(customer);
                            }
                        });

                        arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.name > b?.name ? 1 : -1);
                        setCustomersSel(arrayObj?.arrayValues);
                        setUsersCustomerSel([]);
                        setSystemAccess({
                            ...systemAccess,
                            companyId: companyId,
                            customerId: 0,
                            userId: '',
                            informCreationUserId: userRoles?.isAdmin ? '' : systemAccess?.informCreationUserId,
                        });
                        setControlsStatus_((prev) => ({ ...prev, customer: companyId === 0, userCustomer: true, userInformCreation: true, }));
                        setUsers([]);
                    }
                    break;
                case 2:
                    if (customerId !== -1) {
                        arrayObj.array = _userCompanyCustomers?.filter(({ customerId: ci }) => ci === customerId) || [];

                        response = lodash?.unique({ data: arrayObj.array, key: 'userId', subMethod: currentMethod });
                        if (!response.isSuccess || response?.isWarning) return response;

                        arrayObj.array = response?.result;
                        arrayObj?.array?.forEach((ucc) => {
                            const customerUser = _customerUsers?.filter(({ id }) => id === ucc?.userId)?.[0] || {};
                            if (!isUndNullEmp({ data: customerUser, subMethod: currentMethod, })?.result) {
                                arrayObj.arrayValues.push(customerUser);
                            }
                        });

                        arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
                        setUsersCustomerSel(arrayObj?.arrayValues);
                        setSystemAccess({
                            ...systemAccess,
                            customerId: customerId,
                            userId: '',
                            informCreationUserId: userRoles?.isAdmin ? '' : systemAccess?.informCreationUserId,
                        });
                        setControlsStatus_((prev) => ({ ...prev, customer: false, userCustomer: customerId === 0, userInformCreation: true, }));
                        setUsers([]);
                    }
                    break;
                case 3:
                    if (!isUndNullEmp({ data: userId, subMethod: currentMethod })?.result) {
                        arrayObj.arrayValues = _customerUsers?.filter(({ id, }) => id === userId) || [];

                        arrayObj.arrayValues = arrayObj?.arrayValues?.concat(_analysts);
                        arrayObj.arrayValues = arrayObj?.arrayValues?.concat(_admins);

                        arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
                        setUsers(arrayObj?.arrayValues);
                    }
                    setSystemAccess({
                        ...systemAccess,
                        userId: userId,
                        informCreationUserId: userRoles?.isAdmin ? '' : systemAccess?.informCreationUserId,
                    });
                    setControlsStatus_((prev) => ({ ...prev, userInformCreation: isUndNullEmp({ data: userId, subMethod: currentMethod })?.result, }));
                    break;
                case 4:
                    //#region companies
                    response = lodash?.unique({ data: _userCompanyCustomers, key: 'companyId', subMethod: currentMethod });
                    if (!response.isSuccess || response?.isWarning) return response;

                    arrayObj.array = response?.result;
                    arrayObj?.array?.forEach((ucc) => {
                        const company = _companies?.filter(({ id }) => id === ucc?.companyId)?.[0] || {};
                        if (!isUndNullEmp({ data: company, subMethod: currentMethod, })?.result) {
                            arrayObj.arrayValues.push(company);
                        }
                    });

                    arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.name > b?.name ? 1 : -1);
                    setCompaniesSel(arrayObj?.arrayValues);
                    //#endregion companies

                    //#region status
                    _status?.forEach((status) => {
                        const statusLabel = !isUndNullEmp({ data: status?.label, subMethod: currentMethod })?.result ?
                            status?.label :
                            `${status?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${status?.name?.replace(' ', '')?.slice(1)}`;
                        status.label = labels?.[statusLabel]?.[languageObj?.id];
                        //status.label = labels?.[statusLabel]?.['es'];
                    });
                    _status = _status?.sort((a, b) => a?.label > b?.label ? 1 : -1);
                    setStatus(_status);
                    //#endregion status

                    //#region types
                    _types?.forEach((type) => {
                        const typeLabel = !isUndNullEmp({ data: type?.label, subMethod: currentMethod })?.result ?
                            type?.label :
                            `${type?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${type?.name?.replace(' ', '')?.slice(1)}`;
                        type.label = labels?.[typeLabel]?.[languageObj?.id];
                        //type.label = labels?.[typeLabel]?.['es'];
                    });
                    _types = _types?.sort((a, b) => a?.label > b?.label ? 1 : -1);
                    setTypes(_types);
                    //#endregion types

                    //#region customers
                    if (companyId !== -1) {
                        arrayObj = {
                            array: [],
                            arrayValues: [],
                        };
                        arrayObj.array = _userCompanyCustomers?.filter(({ companyId: ci }) => ci === companyId) || [];

                        response = lodash?.unique({ data: arrayObj.array, key: 'customerId', subMethod: currentMethod });
                        if (!response.isSuccess || response?.isWarning) {
                            return response;
                        }

                        arrayObj.array = response?.result;
                        arrayObj?.array?.forEach((ucc) => {
                            const customer = _customers?.filter(({ id }) => id === ucc?.customerId)?.[0] || {};
                            if (!isUndNullEmp({ data: customer, subMethod: currentMethod, })?.result) {
                                arrayObj.arrayValues.push(customer);
                            }
                        });

                        arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.name > b?.name ? 1 : -1);
                        setCustomersSel(arrayObj?.arrayValues);
                    }
                    //#endregion customers

                    //#region customerusers
                    if (customerId !== -1) {
                        arrayObj = {
                            array: [],
                            arrayValues: [],
                        };
                        arrayObj.array = _userCompanyCustomers?.filter(({ customerId: ci }) => ci === customerId) || [];

                        response = lodash?.unique({ data: arrayObj.array, key: 'userId', subMethod: currentMethod });
                        if (!response.isSuccess || response?.isWarning) return response;

                        arrayObj.array = response?.result;
                        arrayObj?.array?.forEach((ucc) => {
                            const customerUser = _customerUsers?.filter(({ id }) => id === ucc?.userId)?.[0] || {};
                            if (!isUndNullEmp({ data: customerUser, subMethod: currentMethod, })?.result) {
                                arrayObj.arrayValues.push(customerUser);
                            }
                        });

                        arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
                        setUsersCustomerSel(arrayObj?.arrayValues);
                    }
                    //#endregion customerusers

                    //#region informcreationuserid
                    if (!isUndNullEmp({ data: userId, subMethod: currentMethod })?.result) {
                        arrayObj = {
                            array: [],
                            arrayValues: [],
                        };
                        arrayObj.arrayValues = _customerUsers?.filter(({ id, }) => id === userId) || [];

                        arrayObj.arrayValues = arrayObj?.arrayValues?.concat(_analysts);
                        arrayObj.arrayValues = arrayObj?.arrayValues?.concat(_admins);

                        arrayObj.arrayValues = arrayObj?.arrayValues?.sort((a, b) => a?.firstName > b?.firstName ? 1 : -1);
                        setUsers(arrayObj?.arrayValues);
                    }
                    //#endregion informcreationuserid

                    setControlsStatus_((prev) => ({
                        ...prev,
                        customer: companyId === 0,
                        userCustomer: customerId === 0,
                        userInformCreation: isUndNullEmp({ data: userId, subMethod: currentMethod })?.result,
                    }));
                    break;
                default:
                    break;
            }
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            if (showMsgError) {
                await handleResponseMessageAsync({
                    response,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                });
                return;
            }
        }
        return response;
    }

    const formDataSetAsync = async ({
        e = {},
        type = '',
        value = '',
        subMethod = ''
    } = {}) => {
        const currentMethod = 'formDataSetAsync';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            //#region process
            switch (type) {
                case 'commentary':
                    setSystemAccess({ ...systemAccess, [type]: value, });
                    setCharactersRemaining(
                        charactersRemainingGet({
                            text: value,
                            maxLength: dataFormLength?.max?.commentary,
                            msgText: `${messages?.charactersRemaining?.[languageObj?.id]}:`,
                            subMethod: `${currentMethod}`,
                        })?.result
                    );
                    break;
                default:
                    break;
            }
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            await handleResponseMessageAsync({
                response,
                currentMethod: currentMethod,
                languageId: languageObj?.id,
            });
        }
        return response;
    }

    const setDateInControl = async ({
        _date = undefined,
        _userRegisterDate = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDateInControl';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let userRegisterDate = '';
            const tf = languageObj?.format?.time?.type;
            const dtf = `${languageObj?.format?.date?.f11} ${languageObj?.format?.time?.picker?.hhmm}`;
            const df = languageObj?.format?.date?.f1;
            //#endregion variables

            //#region methods
            if (!isUndNullEmp({ data: _userRegisterDate, subMethod: currentMethod })?.result) {
                userRegisterDate = setDateTimeFormatGlobalString({ date: _userRegisterDate, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            } else if (!isUndNullEmp({ data: _date, subMethod: currentMethod })?.result) {
                userRegisterDate = setDateTimeFormatGlobalString({ date: _date, dateFormat: df, timeFormat: tf, withSeconds: false, subMethod: currentMethod, })?.result;
            }

            $.fn.datetimepicker.Constructor.Default = $.extend({}, $.fn.datetimepicker.Constructor.Default, {
                icons: settings?.react?.tempusDominus?.icons,
                buttons: settings?.react?.tempusDominus?.buttons,
                tooltips: settings?.react?.tempusDominus?.tooltips({ languageId: languageObj?.id }),
                locale: languageObj?.id,
            });

            $(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker(
                'options',
                {
                    //date: moment(`${dateTime}`, dateTimeFormat, true),
                    //date: moment(dateTime).format(dateTimeFormat),
                    date: userRegisterDate,
                    default: false,
                    timepicker: true,
                    format: dtf,
                    //format: 'L',
                }
            );

            $(`#${controls?.pickers?.userRegisterDate?.id}`)?.on('click keydown', (e) => {
                const chkUserInformCompletionBefore = $(`#${controls?.checkBoxs?.userInformCompletionBefore?.id}`);
                if (systemAccessBefore?.informCompletion ||
                    chkUserInformCompletionBefore?.prop('checked')) {
                    e?.preventDefault?.();
                    return false;
                }
            });
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const goToBack = async ({
        e = {},
        _processType = 0,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'goToBack';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            //#endregion variables

            //#region process
            setProcess(prev => ({ ...prev, back: _processType === 0, edit: _processType === 1, showLoading: true }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond, });

            window.location.href = _processType === 0 ? componentUrls?.back : `${componentUrls?.edit}${systemAccess?.id || 0}`;
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, back: false, edit: false, showLoading: false }));

            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    setShowData: setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: languageObj?.id
                });
            }
        }
    }

    const setErrorsDefault = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors(prev => ({
                ...prev,
                company: '',
                customer: '',
                userCustomer: '',
                type: '',
                commentary: '',
                analyst: '',
                status: '',
                userRegisterDate: '',
                userInformCreation: ''
            }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const registerDate = new Date();
            const userRegisterDate = userRoles?.isAdmin ?
                $(`#${controls?.pickers?.userRegisterDate?.id}`)?.datetimepicker('date')?._d :
                registerDate;
            //#endregion variables

            //#region methods
            systemAccess.registerDate = moment(registerDate).format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`);
            systemAccess.userRegisterDate = moment(userRegisterDate).format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`);
            systemAccess.informCreationDate = moment(registerDate).format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`);
            systemAccess.informCompletionDate = moment(registerDate).format(`${languageObj?.format?.date?.f13}T${languageObj?.format?.time?.f2}.000Z`);
            //#endregion methods
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            const registerDate = userRoles?.isAdmin ?
                $(`#${controls?.inputs?.userRegisterDate.id}`).val() :
                systemAccess?.userRegisterDate;
            const thisFieldRequired = `${messages?.thisFieldRequired?.[languageObj?.id]}.`;
            const errors_ = { company: '', customer: '', userCustomer: '', type: '', commentary: '', analyst: '', status: '', userRegisterDate: '', userInformCreation: '' };
            //#endregion variables

            //#region method
            if (isUndNullEmp({ data: systemAccess, subMethod: currentMethod })?.result) {
                errors_.company = thisFieldRequired;
                errors_.customer = thisFieldRequired;
                errors_.userCustomer = thisFieldRequired;
                errors_.type = thisFieldRequired;
                errors_.commentary = thisFieldRequired;
                errors_.analyst = thisFieldRequired;
                errors_.userRegisterDate = thisFieldRequired;
                errors_.status = thisFieldRequired;
                errors_.userInformCreation = thisFieldRequired;
                response.isWarning = true;
            };

            if (isUndNullEmp({ data: systemAccess?.companyId, subMethod: currentMethod })?.result ||
                parseInt(systemAccess?.companyId) <= 0) {
                errors_.company = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: systemAccess?.customerId, subMethod: currentMethod })?.result ||
                parseInt(systemAccess?.customerId) <= 0) {
                errors_.customer = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: systemAccess?.userId, subMethod: currentMethod })?.result) {
                errors_.userCustomer = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: systemAccess?.typeId, subMethod: currentMethod })?.result ||
                parseInt(systemAccess?.typeId) <= 0) {
                errors_.type = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: systemAccess?.commentary, subMethod: currentMethod })?.result) {
                errors_.commentary = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: systemAccess?.analystId, subMethod: currentMethod })?.result) {
                errors_.analyst = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: registerDate, subMethod: currentMethod })?.result) {
                errors_.userRegisterDate = thisFieldRequired;
                response.isWarning = true;
            } else if (!isUndNullEmp({ data: registerDate, subMethod: currentMethod })?.result && !isValidDate({ data: registerDate, subMethod: currentMethod })?.result) {
                errors_.userRegisterDate = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: systemAccess?.statusId, subMethod: currentMethod })?.result ||
                parseInt(systemAccess?.statusId) <= 0) {
                errors_.status = thisFieldRequired;
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: systemAccess?.informCreationUserId, subMethod: currentMethod })?.result) {
                errors_.userInformCreation = thisFieldRequired;
                response.isWarning = true;
            }
            //#endregion method

            if (response?.isWarning) {
                setErrors(prev => ({
                    ...prev,
                    ...errors_
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDataTables';
        let response = getResponse({ type: 0 });
        try {
            $(`#${dtSystemAccessesDetailsId}`)?.DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: 'DateTime', width: '0%', visible: false, orderable: false, searchable: false, },
                    { title: labels?.date?.[languageObj?.id], width: '10%', },
                    { title: labels?.time?.[languageObj?.id], width: '10%', },
                    { title: labels?.analyst?.[languageObj?.id], width: '20%', },
                    { title: labels?.commentary?.[languageObj?.id], width: '55%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'asc']],
                //order: [[0, 'desc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtSystemAccessesDetailsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setQueryCode';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let id_ = '';
            let methodName = '';
            let description = '';
            let rowId = 0;
            //#endregion variables

            //#region process
            $(`#${dtSystemAccessesDetailsId} tbody`).on('click', 'tr', 'td', async function (e) {
                rowId = getDtRowIndex({ dtId: dtSystemAccessesDetailsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    methodName = e?.target?.attributes?.method?.value || '';
                    id_ = e?.target?.attributes?.id?.value || '';
                    description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getSystemAccessDetailAddDetailEditPrev({ e: e, id: parseInt(id_), description: description, processType: 1, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            getSystemAccessDetailAddDetailEditPrev({ e: e, id: parseInt(id_), description: description, processType: 2, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            getSystemAccessDetailAddDetailEditPrev({ e: e, id: parseInt(id_), description: description, processType: -1, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        systemAccess = {},
        analysts = [],
        status = [],
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setDataInDataTable';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let rowsDt = [];
            let statusObj = {
                finalized: {
                    label: labels?.finalized?.en,
                    model: Status?.getClass({}, false),
                },
            };
            let modelSystemAccess = SystemAccess?.class(systemAccess, false);
            //#endregion variables

            //#region process
            statusObj = {
                ...statusObj,
                finalized: {
                    ...statusObj?.finalized,
                    model: status?.filter(({ name, label, }) => label === statusObj?.finalized?.label || name === statusObj?.finalized?.label)?.[0] || {},
                },
            };

            data?.forEach((systemAccessDetail) => {
                //#region variables
                const modelSystemAccessDetail = SystemAccessDetail?.class(systemAccessDetail, false);
                let analystObj = {
                    model: User?.getClass({}, false),
                    label: '',
                    labelHtml: '',
                };
                analystObj.model = analysts?.filter(({ id, }) => id === modelSystemAccessDetail?.analystId)?.[0] || {}
                analystObj.label = `${analystObj?.model?.firstName || ''} ${analystObj?.model?.lastName || ''}`;
                analystObj.labelHtml = analystObj?.label;
                const registerDate = setDateTimeFormatGlobalString({
                    date: modelSystemAccessDetail?.userRegisterDate,
                    dateFormat: languageObj?.format?.date?.f1,
                    timeFormat: 0,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const registerTime = setDateTimeFormatGlobalString({
                    date: modelSystemAccessDetail?.userRegisterDate,
                    dateFormat: '',
                    timeFormat: languageObj?.format?.time?.type,
                    withSeconds: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
                const processButtonObj = {
                    description: `${registerDate} ${registerTime} - ${analystObj?.labelHtml}`,
                    showEdit: ((userRoles?.isAdmin || userRoles?.isAnalyst) && viewParams?.type === 1 && modelSystemAccess?.statusId !== statusObj?.finalized?.model?.id),
                    //showDelete: ((userRoles?.isAdmin || userRoles?.isAnalyst) && viewParams?.type === 1 && modelSystemAccess?.statusId !== statusObj?.finalized?.model?.id),
                    showDelete: ((userRoles?.isAdmin) && viewParams?.type === 1 && modelSystemAccess?.statusId !== statusObj?.finalized?.model?.id),
                };
                const processButtons = [
                    // {
                    //     isVisible: true,
                    //     showDivider: true,
                    //     isEnabled: true,
                    //     methodName: 'getExcel',
                    //     icon: icons?.fileExcelFas,
                    //     label: `${labels?.getExcel[languageObj?.id]}`
                    // },
                ];
                //#endregion variables

                //#region process
                rowsDt.push([
                    modelSystemAccessDetail?.userRegisterDate,
                    registerDate || '',
                    registerTime || '',
                    analystObj?.labelHtml || '',
                    modelSystemAccessDetail?.commentary,
                    getProcessButtons({
                        id: systemAccessDetail?.id,
                        description: processButtonObj?.description,
                        showDetails: true,
                        labelDetails: labels?.details?.[languageObj?.id],
                        enabledDetails: true,
                        showDelete: processButtonObj?.showDelete,
                        labelDelete: labels?.delete?.[languageObj?.id],
                        enabledDelete: processButtonObj?.showDelete,
                        showEdit: processButtonObj?.showEdit,
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: processButtonObj?.showEdit,
                        processButtons: processButtons,
                    })?.result,
                ]);
                //#endregion process
            });
            $(`#${dtSystemAccessesDetailsId}`)?.DataTable()?.rows?.add(rowsDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const dataFieldsSet = ({
        systemAccess = {},
        systemAccessDetails = [],
        admins = [],
        analysts = [],
        companies = [],
        customers = [],
        customerUsers = [],
        status = [],
        types = [],
        subMethod = '',
    } = {}) => {
        const currentMethod = 'dataFieldsSet';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let saFieldViews = saFieldViewsObj;
            //#endregion variables

            //#region method
            //#region company / customer / userregisterdate
            saFieldViews.model = SystemAccess?.class(systemAccess, false);
            saFieldViews.company.model = Company?.getClass(companies?.filter(({ id, }) => id === saFieldViews?.model?.companyId)?.[0] || {}, false);
            saFieldViews.company.html = `${saFieldViews?.company?.model?.name}`;

            saFieldViews.customer.model = Customer?.getClass(customers?.filter(({ id, }) => id === saFieldViews?.model?.customerId)?.[0] || {}, false);
            saFieldViews.customer.html = `${saFieldViews?.customer?.model?.name}`;

            saFieldViews.register.date = setDateTimeFormatGlobalString({
                date: saFieldViews?.model?.userRegisterDate,
                dateFormat: languageObj?.format?.date?.f1,
                timeFormat: 0,
                withSeconds: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            saFieldViews.register.time = setDateTimeFormatGlobalString({
                date: saFieldViews?.model?.userRegisterDate,
                dateFormat: '',
                timeFormat: languageObj?.format?.time?.type,
                withSeconds: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;

            saFieldViews.register.html = `${saFieldViews?.register?.date} ${saFieldViews?.register?.time}`
            //#endregion company / customer / userregisterdate

            //#region status
            saFieldViews.status.model = status?.filter(({ id, }) => id === saFieldViews?.model?.statusId)?.[0] || {}
            saFieldViews.status.label = !isUndNullEmp({ data: saFieldViews?.status?.model?.label, subMethod: currentMethod }) ?
                saFieldViews?.status?.model?.label :
                `${saFieldViews?.status?.model?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${saFieldViews?.status?.model?.name?.replace(' ', '')?.slice(1)}`;
            saFieldViews.status.html = badgetStatusGeneric({
                type: (saFieldViews?.status?.model?.id === 1 ? 1 :
                    (saFieldViews?.status?.model?.id === 2 ? 5 :
                        (saFieldViews?.status?.model?.id === 3 ? 3 :
                            (saFieldViews?.status?.model?.id === 4 ? 0 :
                                (saFieldViews?.status?.model?.id === 5 ? -1 :
                                    (saFieldViews?.status?.model?.id === 6 ? 2 : 4)))))),
                value: labels?.[saFieldViews?.status?.label]?.[languageObj?.id] || 'undefined',
            });
            //#endregion status

            //#region type
            saFieldViews.type.model = types?.filter(({ id, }) => id === saFieldViews?.model?.typeId)?.[0] || {}
            saFieldViews.type.label = !isUndNullEmp({ data: saFieldViews?.type?.model?.label, subMethod: currentMethod }) ?
                saFieldViews?.type?.model?.label :
                `${saFieldViews?.type?.model?.name?.replace(' ', '')?.charAt(0)?.toLowerCase()}${saFieldViews?.type?.model?.name?.replace(' ', '')?.slice(1)}`;
            saFieldViews.type.html = badgetStatusGeneric({
                type: (saFieldViews?.type?.model?.id === 1 ? 5 :
                    (saFieldViews?.type?.model?.id === 2 ? 1 :
                        (saFieldViews?.type?.model?.id === 3 ? 2 :
                            (saFieldViews?.type?.model?.id === 4 ? -1 : 5)))),
                value: labels?.[saFieldViews?.type?.label]?.[languageObj?.id] || 'undefined',
            });
            //#endregion type

            //#region user / analyst / commentary
            saFieldViews.user.model = customerUsers?.filter(({ id, }) => id === saFieldViews?.model?.userId)?.[0] || {};
            saFieldViews.user.html = `${saFieldViews?.user?.model?.firstName || ''} - ${saFieldViews?.user?.model?.lastName || ''}`;

            saFieldViews.analyst.model = analysts?.filter(({ id, }) => id === saFieldViews?.model?.analystId)?.[0] || {};
            saFieldViews.analyst.html = `${saFieldViews?.analyst?.model?.firstName || ''} - ${saFieldViews?.analyst?.model?.lastName || ''}`;

            saFieldViews.commentary = `${saFieldViews?.model?.commentary || ''}`;
            //#endregion user / analyst / commentary

            //#region userinforcreation / informcreation / informcompletion
            let allUsers = admins?.concat(analysts)?.concat(customerUsers);

            //#region informcreation
            saFieldViews.informCreation.status = saFieldViews?.model?.informCreation;
            saFieldViews.informCreation.user.model = allUsers?.filter(({ id, }) => id === saFieldViews?.model?.informCreationUserId)?.[0] || {};
            saFieldViews.informCreation.user.html = `${saFieldViews?.informCreation?.user?.model?.firstName || ''} - ${saFieldViews?.informCreation?.user?.model?.lastName || ''}`;

            saFieldViews.informCreation.date = setDateTimeFormatGlobalString({
                date: saFieldViews?.model?.informCreationDate,
                dateFormat: languageObj?.format?.date?.f1,
                timeFormat: 0,
                withSeconds: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            saFieldViews.informCreation.time = setDateTimeFormatGlobalString({
                date: saFieldViews?.model?.informCreationDate,
                dateFormat: '',
                timeFormat: languageObj?.format?.time?.type,
                withSeconds: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            saFieldViews.informCreation.html = `${saFieldViews?.informCreation?.date} ${saFieldViews?.informCreation?.time}`
            //#endregion informcreation

            //#region informcompletion
            saFieldViews.informCompletion.status = saFieldViews?.model?.informCompletion;

            saFieldViews.informCompletion.date = setDateTimeFormatGlobalString({
                date: saFieldViews?.model?.informCompletionDate,
                dateFormat: languageObj?.format?.date?.f1,
                timeFormat: 0,
                withSeconds: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            saFieldViews.informCompletion.time = setDateTimeFormatGlobalString({
                date: saFieldViews?.model?.informCompletionDate,
                dateFormat: '',
                timeFormat: languageObj?.format?.time?.type,
                withSeconds: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            })?.result;
            saFieldViews.informCompletion.html = `${saFieldViews?.informCompletion?.date} ${saFieldViews?.informCompletion?.time}`
            //#endregion informcompletion
            //#endregion userinforcreation / informcreation / informcompletion
            setSaFieldViews(saFieldViews);
            //#endregion method
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.systemAccesses?.systemAccesses} process={app?.views?.systemAccesses?.systemAccesses} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.systemAccesses?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item'><a href={backend?.urls?.systemAccesses}>{labels?.systemAccesses?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>
                                        {viewParams?.type === 0 ? labels?.create?.[languageObj?.id] :
                                            viewParams?.type === 1 ? labels?.edit?.[languageObj?.id] : labels?.details?.[languageObj?.id]}
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                {showData ? (
                                    <div className='col-12'>
                                        <form onSubmit={(e) => viewParams?.type === 0 ?
                                            addSystemAccess({ e: e, subMethod: 'formSystemAccess' }) : editSystemAccess({ e: e, subMethod: 'formSystemAccess' })}>
                                            <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                                <LoadingSection alt='loadingSection'
                                                    className='overlay dark text-white'
                                                    height={20}
                                                    hidden={!process?.showLoading}
                                                    width={20}
                                                    languageId={languageObj?.id}
                                                    subMethod={currentMethod} />

                                                <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                    <div className='d-flex align-items-center'>
                                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <img alt='systemAccesses' style={styles?.cardHeaderLogo} src={images?.icons?.systemAccesses}></img>
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.systemAccesses?.[languageObj?.id]}</h5>
                                                            <div className='mt-1'>
                                                                <span className={`badge badge-pill px-2 py-1 text-uppercase ${viewParams?.type === 0 ? 'badge-primary' : viewParams?.type === 1 ? 'badge-warning' : 'badge-secondary'}`}
                                                                    style={html?.badges?.micro}>
                                                                    <i className={`${viewParams?.type === 0 ? icons?.fasFa?.plus : viewParams?.type === 1 ? icons?.fasFa?.edit : icons?.fasFa?.eye} mr-1`}></i>
                                                                    {viewParams?.type === 0 ? labels?.create?.[languageObj?.id] :
                                                                        viewParams?.type === 1 ? labels?.edit?.[languageObj?.id] :
                                                                            labels?.details?.[languageObj?.id]}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className='card-body px-4 pb-4'>
                                                    {viewParams?.type !== 2 ?
                                                        <>
                                                            <div className='row'>
                                                                <div className='col-12 col-md-2'>
                                                                    <div className='form-group'>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={icons?.fasFa?.hashTag} /> {labels?.number?.[languageObj?.id]}
                                                                        </small>
                                                                        <input id={controls?.inputs?.id?.id}
                                                                            className={controls?.inputs?.id?.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            placeholder={labels?.id?.[languageObj?.id]}
                                                                            readOnly
                                                                            disabled
                                                                            title={labels?.number?.[languageObj?.id]}
                                                                            value={systemAccess?.id || 0} />
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-5'>
                                                                    <div className='form-group'>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={icons?.fasFa?.building} /> {labels?.company?.[languageObj?.id]}
                                                                        </small>
                                                                        <select id={controls?.selects?.company?.id}
                                                                            className={controls?.selects?.company?.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            value={systemAccess?.companyId || 0}
                                                                            onChange={(e) => {
                                                                                !systemAccessBefore?.informCompletion ?
                                                                                    dataGeneralSetAsync({ processType: 1, companyId: parseInt(e?.target?.value), showMsgError: true, subMethod: controls?.selects?.company?.id, }) :
                                                                                    e?.preventDefault?.();
                                                                            }}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, company: '' }))}
                                                                            placeholder={labels?.company?.[languageObj?.id]}
                                                                            title={labels?.company?.[languageObj?.id]}>
                                                                            <option key={0} value={0}>{messages?.selectCompany?.[languageObj?.id]}</option>
                                                                            {companiesSel?.map((company) => <option key={company?.id} value={company?.id}>{company?.name}</option>)}
                                                                        </select>
                                                                        <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.company || '')}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-5'>
                                                                    <div className='form-group'>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={icons?.fasFa?.user} /> {labels?.customer?.[languageObj?.id]}
                                                                        </small>
                                                                        <select id={controls?.selects?.customer?.id}
                                                                            className={controls?.selects?.customer?.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            disabled={controlsStatus_?.customer}
                                                                            value={systemAccess?.customerId || 0}
                                                                            onChange={(e) => {
                                                                                !systemAccessBefore?.informCompletion ?
                                                                                    dataGeneralSetAsync({ processType: 2, customerId: parseInt(e?.target?.value), showMsgError: true, subMethod: controls?.selects?.usersCustomer?.id, }) :
                                                                                    e?.preventDefault?.();
                                                                            }}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, customer: '' }))}
                                                                            placeholder={labels?.customer?.[languageObj?.id]}
                                                                            title={labels?.customer?.[languageObj?.id]}>
                                                                            <option key={0} value={0}>{messages?.selectCustomer?.[languageObj?.id]}</option>
                                                                            {customersSel?.map((customer) => <option key={customer?.id} value={customer?.id}>{customer?.name}</option>)}
                                                                        </select>
                                                                        <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.customer)}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-12 col-md-4'>
                                                                    <div className='form-group'>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={icons?.fasFa?.user} /> {labels?.user?.[languageObj?.id]}
                                                                        </small>
                                                                        <select id={controls?.selects?.usersCustomer?.id}
                                                                            className={controls?.selects?.usersCustomer?.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            disabled={controlsStatus_?.userCustomer}
                                                                            value={systemAccess?.userId || ''}
                                                                            onChange={(e) => {
                                                                                !systemAccessBefore?.informCompletion ?
                                                                                    dataGeneralSetAsync({ processType: 3, userId: e?.target?.value, showMsgError: true, subMethod: controls?.selects?.usersCustomer?.id }) :
                                                                                    e?.preventDefault?.();
                                                                            }}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, userCustomer: '' }))}
                                                                            placeholder={labels?.user?.[languageObj?.id]}
                                                                            title={labels?.user?.[languageObj?.id]}>
                                                                            <option key={'nothing'} value={''}>{messages?.selectUser?.[languageObj?.id]}</option>
                                                                            {usersCustomerSel?.map((user) => <option key={user?.id} value={user?.id}>{`${user?.firstName || ''} ${user?.lastName || ''}`}</option>)}
                                                                        </select>
                                                                        <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.userCustomer)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-4'>
                                                                    <div className='form-group'>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={icons?.fasFa?.list} /> {labels?.type?.[languageObj?.id]}
                                                                        </small>
                                                                        <select id={controls?.selects?.types?.id}
                                                                            className={controls?.selects?.types?.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            value={systemAccess?.typeId || 0}
                                                                            onChange={(e) => {
                                                                                !systemAccessBefore?.informCompletion ?
                                                                                    setSystemAccess({ ...systemAccess, typeId: parseInt(e?.target?.value), }) :
                                                                                    e?.preventDefault?.();
                                                                            }}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, type: '' }))}
                                                                            placeholder={labels?.type?.[languageObj?.id]}
                                                                            title={labels?.type?.[languageObj?.id]}>
                                                                            <option key={0} value={0}>{messages?.selectType?.[languageObj?.id]}</option>
                                                                            {types?.map((type) => <option key={type?.id} value={type?.id}>{type?.label}</option>)}
                                                                        </select>
                                                                        <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.type)}</div>
                                                                    </div>
                                                                </div>
                                                                <div className='col-12 col-md-4'>
                                                                    <div className='form-group'
                                                                        hidden={systemAccess?.statusId !== statusObj?.finalized?.model?.id}>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={icons?.fasFa?.exclamationTrinagle} /> {labels?.information?.[languageObj?.id]}
                                                                        </small>
                                                                        <div className='alert alert-warning border-0 shadow-sm mb-0 py-2'>
                                                                            {/* <i className={`${icons?.fasFaexclamationTrinagle} mr-2`} /> {parse(messages?.onceFinalizedItCanNotBeEdited?.[languageObj?.id])} */}
                                                                            {parse(messages?.onceFinalizedItCanNotBeEdited?.[languageObj?.id])}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='row'>
                                                                <div className='col-12'>
                                                                    <div className='form-group'>
                                                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                            <i className={icons?.fasFa?.edit} /> {labels?.observation?.[languageObj?.id]}
                                                                        </small>
                                                                        <textarea id={controls?.textAreas?.commentary?.id}
                                                                            className={controls?.textAreas?.commentary?.defaultClass}
                                                                            style={{ borderRadius: '5px' }}
                                                                            maxLength={dataFormLength?.max?.commentary}
                                                                            placeholder={labels?.commentary?.[languageObj?.id]}
                                                                            onChange={(e) => {
                                                                                !systemAccessBefore?.informCompletion ?
                                                                                    formDataSetAsync({ e: e, type: 'commentary', value: e?.target?.value, subMethod: controls?.textAreas?.commentary?.id }) :
                                                                                    e?.preventDefault?.();
                                                                            }}
                                                                            onFocus={() => setErrors(prev => ({ ...prev, commentary: '' }))}
                                                                            rows={2}
                                                                            value={systemAccess?.commentary || ''}
                                                                            tooltip='tooltip'
                                                                            title={labels?.commentary?.[languageObj?.id]} />
                                                                        <div className='d-flex justify-content-between mt-1'>
                                                                            <div className='form-text text-muted' style={styles?.labelMsgInfo}>{parse(charactersRemaining)}</div>
                                                                            <div className='form-text text-danger' style={styles?.labelMsgAlert}>{parse(errors?.commentary || '')}</div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {userRoles?.isAdmin && (
                                                                <>
                                                                    <hr className='my-4' />
                                                                    <div className='row'>
                                                                        <div className='col-12 col-md-4'>
                                                                            <div className='form-group'>
                                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                                    <i className={icons?.fasFa?.userTie} /> {labels?.analyst?.[languageObj?.id]}
                                                                                </small>
                                                                                <select id={controls?.selects?.analysts?.id}
                                                                                    className={controls?.selects?.analysts?.defaultClass}
                                                                                    style={{ borderRadius: '5px' }}
                                                                                    value={systemAccess?.analystId || 0}
                                                                                    onChange={(e) => {
                                                                                        !systemAccessBefore?.informCompletion ?
                                                                                            setSystemAccess({ ...systemAccess, analystId: e?.target?.value, }) :
                                                                                            e?.preventDefault?.();
                                                                                    }}
                                                                                    onFocus={() => setErrors(prev => ({ ...prev, analyst: '' }))}
                                                                                    placeholder={labels?.analyst?.[languageObj?.id]}
                                                                                    title={labels?.analyst?.[languageObj?.id]}>
                                                                                    <option key={'nothing'} value={''}>{messages?.selectAnalyst?.[languageObj?.id]}</option>
                                                                                    {analysts?.map((analyst) => <option key={analyst?.id} value={analyst?.id}>{`${analyst?.firstName || ''} ${analyst?.lastName || ''} - ${analyst?.department || ''}`}</option>)}
                                                                                </select>
                                                                                <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.analyst || '')}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-12 col-md-4'>
                                                                            <div className='form-group'>
                                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                                    <i className={icons?.faFa?.calendarAlt} /> {labels?.register?.[languageObj?.id]}
                                                                                </small>
                                                                                {!isUndNullEmp({ data: systemAccess?.registerDate, subMethod: controls?.inputs?.userRegisterDate?.id, })?.result ?
                                                                                    <div id={controls?.pickers?.userRegisterDate?.id} className='input-group date' data-target-input='nearest'>
                                                                                        <input id={controls?.inputs?.userRegisterDate.id}
                                                                                            className={controls?.inputs?.userRegisterDate?.defaultClass}
                                                                                            style={{ borderRadius: '5px' }}
                                                                                            data-target={`#${controls?.pickers?.userRegisterDate?.id}`}
                                                                                            data-toggle='datetimepicker'
                                                                                            disabled={systemAccessBefore?.informCompletion}
                                                                                            onFocus={() => setErrors(prev => ({ ...prev, userRegisterDate: '' }))}
                                                                                            placeholder={labels?.register?.[languageObj?.id]}
                                                                                            title={labels?.register?.[languageObj?.id]}
                                                                                            type='text' />
                                                                                        <div className='input-group-append' data-target={`#${controls?.pickers?.userRegisterDate?.id}`} data-toggle='datetimepicker'>
                                                                                            <div className='input-group-text bg-secondary border-0'><i className={icons?.faFa?.calendarAlt} /></div>
                                                                                        </div>
                                                                                    </div>
                                                                                    : <div></div>}
                                                                                <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.userRegisterDate || '')}</div>
                                                                            </div>
                                                                        </div>
                                                                        <div className='col-12 col-md-4'>
                                                                            <div className='form-group'>
                                                                                <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                                    <i className={icons?.fasFa?.list} /> {labels?.status?.[languageObj?.id]}
                                                                                </small>
                                                                                <select id={controls?.selects?.status?.id}
                                                                                    className={controls?.selects?.status?.defaultClass}
                                                                                    style={{ borderRadius: '5px' }}
                                                                                    disabled={controlsStatus_?.status}
                                                                                    value={systemAccess?.statusId || 0}
                                                                                    onChange={(e) => {
                                                                                        !systemAccessBefore?.informCompletion ?
                                                                                            setSystemAccess({ ...systemAccess, statusId: parseInt(e?.target?.value), }) :
                                                                                            e?.preventDefault?.();
                                                                                    }}
                                                                                    onFocus={() => setErrors(prev => ({ ...prev, status: '' }))}
                                                                                    placeholder={labels?.status?.[languageObj?.id]}
                                                                                    title={labels?.status?.[languageObj?.id]}>
                                                                                    <option key={0} value={0}>{messages?.selectStatus?.[languageObj?.id]}</option>
                                                                                    {status?.map((statu) => <option key={statu?.id} value={statu?.id}>{statu?.label}</option>)}
                                                                                </select>
                                                                                <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.status || '')}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}

                                                            {/*Elemts hide*/}
                                                            <div className='row'
                                                                style={{ display: 'none', }}>
                                                                <div className='col-md-4'></div>
                                                                <div className='col-md-4'></div>
                                                                <div className='col-md-4'>
                                                                    <div className='form-group'>
                                                                        <div className='icheck-primary d-inline'>
                                                                            <input type='checkbox'
                                                                                checked={systemAccess?.informCompletion}
                                                                                id={controls?.checkBoxs?.userInformCompletionBefore?.id}
                                                                                onClick={(e) => {
                                                                                    e?.preventDefault?.();
                                                                                }}
                                                                                onChange={(e) => {
                                                                                    e?.preventDefault?.();
                                                                                }}
                                                                                readOnly />
                                                                            <label htmlFor={controls?.checkBoxs?.userInformCompletionBefore?.id}
                                                                                style={{ fontWeight: 'normal', }}>
                                                                                {`${labels?.informCompletion?.[languageObj?.id]} - before`}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/*Elemts hide*/}
                                                        </>
                                                        :
                                                        <>
                                                            <div className='row'>
                                                                {[
                                                                    { label: labels?.id?.[languageObj?.id], value: saFieldViews?.model?.id || 0, icon: icons?.fasFa?.hashTag, color: 'primary' },
                                                                    { label: labels?.date?.[languageObj?.id], value: saFieldViews?.register?.html || '---', icon: icons?.fasFa?.calendarAlt, color: 'secondary' },
                                                                    { label: labels?.company?.[languageObj?.id], value: saFieldViews?.company?.html || '---', icon: icons?.fasFa?.building, color: 'info' },
                                                                    { label: labels?.customer?.[languageObj?.id], value: saFieldViews?.customer?.html || '---', icon: icons?.fasFa?.building, color: 'success' },
                                                                    { label: labels?.user?.[languageObj?.id], value: parse(saFieldViews?.user?.html || '---'), icon: icons?.fasFa?.user, color: 'warning' },
                                                                    { label: labels?.type?.[languageObj?.id], value: parse(saFieldViews?.type?.html || '---'), icon: icons?.fasFa?.list, color: 'primary' },
                                                                    { label: labels?.analyst?.[languageObj?.id], value: parse(saFieldViews?.analyst?.html || '---'), icon: icons?.fasFa?.userTie, color: 'secondary' },
                                                                    { label: labels?.status?.[languageObj?.id], value: parse(saFieldViews?.status?.html || '---'), icon: icons?.fasFa?.list, color: 'info' },
                                                                    { label: labels?.commentary?.[languageObj?.id], value: parse(saFieldViews?.commentary || '---'), icon: icons?.fasFa?.edit, color: 'primary', wide: true },
                                                                ].map((field, idx) => (
                                                                    <div key={idx} className={`col-12 col-md-${field.wide ? '12' : '6'} mb-3`}>
                                                                        <div className={`p-3 rounded bg-light border-left border-${field.color || 'primary'} shadow-sm h-100`}
                                                                            style={{ borderLeftWidth: '5px' }}>
                                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1'
                                                                                style={html?.labels?.detailMicro}>
                                                                                {field.icon && <i className={`${field.icon} mr-1`} />} {field.label}
                                                                            </small>
                                                                            <span className='text-dark font-weight-bold'>{field.value}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </>
                                                    }
                                                    <div className='row mt-4'>
                                                        {[
                                                            {
                                                                title: labels?.legend?.[languageObj?.id],
                                                                icon: icons?.fasFa?.infoCircle,
                                                                color: 'primary',
                                                                checks: [
                                                                    { id: controls?.checkBoxs?.legendEnabled?.id, label: labels?.enabled?.[languageObj?.id], checked: true, readOnly: true },
                                                                    { id: controls?.checkBoxs?.legendDisabled?.id, label: labels?.disabled?.[languageObj?.id], checked: false, readOnly: true },
                                                                ]
                                                            },
                                                            {
                                                                title: labels?.purchases?.[languageObj?.id],
                                                                icon: icons?.fasFa?.shoppingCart,
                                                                color: 'success',
                                                                checks: [
                                                                    { id: controls?.checkBoxs?.purchase?.id, label: labels?.purchase?.[languageObj?.id], value: systemAccess?.purchase, toggle: () => setSystemAccess({ ...systemAccess, purchase: !systemAccess?.purchase }) },
                                                                    { id: controls?.checkBoxs?.billToPay?.id, label: labels?.billToPay?.[languageObj?.id], value: systemAccess?.billToPay, toggle: () => setSystemAccess({ ...systemAccess, billToPay: !systemAccess?.billToPay }) },
                                                                ]
                                                            },
                                                            {
                                                                title: labels?.request?.[languageObj?.id],
                                                                icon: icons?.fasFa?.fileAlt,
                                                                color: 'info',
                                                                checks: [
                                                                    { id: controls?.checkBoxs?.paymentInformation?.id, label: labels?.paymentInformation?.[languageObj?.id], value: systemAccess?.paymentInformation, toggle: () => setSystemAccess({ ...systemAccess, paymentInformation: !systemAccess?.paymentInformation }) },
                                                                    { id: controls?.checkBoxs?.requirements?.id, label: labels?.requirements?.[languageObj?.id], value: systemAccess?.requirements, toggle: () => setSystemAccess({ ...systemAccess, requirements: !systemAccess?.requirements }) },
                                                                    { id: controls?.checkBoxs?.systemAccess?.id, label: labels?.systemAccess?.[languageObj?.id], value: systemAccess?.systemAccesses, toggle: () => setSystemAccess({ ...systemAccess, systemAccesses: !systemAccess?.systemAccesses }) },
                                                                ]
                                                            },
                                                            {
                                                                title: labels?.services?.[languageObj?.id],
                                                                icon: icons?.fasFa?.cogs,
                                                                color: 'warning',
                                                                checks: [
                                                                    { id: controls?.checkBoxs?.backupReviews?.id, label: labels?.backupReviews?.[languageObj?.id], value: systemAccess?.backupReviews, toggle: () => setSystemAccess({ ...systemAccess, backupReviews: !systemAccess?.backupReviews }) },
                                                                    { id: controls?.checkBoxs?.domainHosting?.id, label: labels?.domainHosting?.[languageObj?.id], value: systemAccess?.domainHosting, toggle: () => setSystemAccess({ ...systemAccess, domainHosting: !systemAccess?.domainHosting }) },
                                                                    { id: controls?.checkBoxs?.dataCenter?.id, label: labels?.dataCenter?.[languageObj?.id], value: systemAccess?.dataCenter, toggle: () => setSystemAccess({ ...systemAccess, dataCenter: !systemAccess?.dataCenter }) },
                                                                    { id: controls?.checkBoxs?.remoteConnectionsDNS?.id, label: labels?.remoteConnectionAbr?.[languageObj?.id], value: systemAccess?.remoteConnectionsDNS, toggle: () => setSystemAccess({ ...systemAccess, remoteConnectionsDNS: !systemAccess?.remoteConnectionsDNS }) },
                                                                    { id: controls?.checkBoxs?.parameters?.id, label: labels?.devices?.[languageObj?.id], value: systemAccess?.parameters, toggle: () => setSystemAccess({ ...systemAccess, parameters: !systemAccess?.parameters }) },
                                                                ]
                                                            }
                                                        ].map((group, gIdx) => (
                                                            <div key={gIdx} className='col-12 col-md-6 col-lg-3 mb-4'>
                                                                <div className={`card h-100 shadow-sm border-0 border-left border-${group.color}`} style={{ borderLeftWidth: '5px' }}>
                                                                    <div className='card-header bg-transparent border-0 py-2'>
                                                                        <small className='text-muted text-uppercase font-weight-bold'>
                                                                            <i className={`${group.icon} mr-1 text-${group.color}`} /> {group.title}
                                                                        </small>
                                                                    </div>
                                                                    <div className='card-body py-2'>
                                                                        {group.checks.map((check, cIdx) => (
                                                                            <div key={cIdx} className='custom-control custom-checkbox mb-2'>
                                                                                <input type='checkbox'
                                                                                    className='custom-control-input'
                                                                                    id={check.id}
                                                                                    checked={check.checked ?? check.value ?? false}
                                                                                    disabled={check.readOnly || systemAccessBefore?.informCompletion || viewParams?.type === 2}
                                                                                    onChange={check.toggle || (() => { })} />
                                                                                <label className='custom-control-label font-weight-normal' htmlFor={check.id} style={{ cursor: 'pointer' }}>
                                                                                    {check.label}
                                                                                </label>
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                    {viewParams?.type !== 2 ?
                                                        <>
                                                            {userRoles?.isAdmin && (
                                                                <div className='row mt-3'>
                                                                    <div className='col-12 col-md-6'>
                                                                        <div className='form-group'>
                                                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                                <i className={icons?.fasFa?.user} /> {labels?.user?.[languageObj?.id]}
                                                                            </small>
                                                                            <select id={controls?.selects?.userInformCreation?.id}
                                                                                className={controls?.selects?.userInformCreation?.defaultClass}
                                                                                style={{ borderRadius: '5px' }}
                                                                                disabled={controlsStatus_?.userInformCreation}
                                                                                value={systemAccess?.informCreationUserId || ''}
                                                                                onChange={(e) => {
                                                                                    !systemAccessBefore?.informCompletion ?
                                                                                        setSystemAccess({ ...systemAccess, informCreationUserId: e?.target?.value, }) :
                                                                                        e?.preventDefault?.();
                                                                                }}
                                                                                onFocus={() => setErrors(prev => ({ ...prev, userInformCreation: '' }))}>
                                                                                <option key={'nothing'} value={''}>{messages?.selectUser?.[languageObj?.id]}</option>
                                                                                {users?.map((user) => <option key={user?.id} value={user?.id}>{`${user?.firstName || ''} ${user?.lastName || ''} - ${user?.department || ''}`}</option>)}
                                                                            </select>
                                                                            <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.userInformCreation || '')}</div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='col-12 col-md-6 d-flex align-items-center'>
                                                                        <div className='custom-control custom-checkbox'>
                                                                            <input type='checkbox'
                                                                                className='custom-control-input'
                                                                                checked={systemAccess?.informCreation || false}
                                                                                disabled={systemAccessBefore?.informCreation || viewParams?.type === 2}
                                                                                id={controls?.checkBoxs?.userInformCreation?.id}
                                                                                onChange={() => setSystemAccess({ ...systemAccess, informCreation: !systemAccess?.informCreation })} />
                                                                            <label className='custom-control-label font-weight-normal' htmlFor={controls?.checkBoxs?.userInformCreation?.id} style={{ cursor: 'pointer' }}>
                                                                                {labels?.informCreation?.[languageObj?.id]}
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </>
                                                        :
                                                        <>
                                                            <div className='row'>
                                                                {[
                                                                    { label: labels?.user?.[languageObj?.id], value: saFieldViews?.informCreation?.user?.html, icon: icons?.fasFa?.user, color: 'primary' },
                                                                    { label: labels?.informCreation?.[languageObj?.id], value: saFieldViews?.informCreation?.status ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id], icon: icons?.fasFa?.checkCircle, color: 'success' },
                                                                    { label: labels?.date?.[languageObj?.id], value: saFieldViews?.informCreation?.html, icon: icons?.fasFa?.calendarAlt, color: 'info' },
                                                                    { label: labels?.informCompletion?.[languageObj?.id], value: saFieldViews?.informCompletion?.status ? labels?.yes?.[languageObj?.id] : labels?.no?.[languageObj?.id], icon: icons?.fasFa?.checkCircle, color: 'success' },
                                                                    { label: labels?.date?.[languageObj?.id], value: saFieldViews?.informCompletion?.html, icon: icons?.fasFa?.calendarAlt, color: 'info' },
                                                                ].map((field, idx) => (
                                                                    <div key={idx} className='col-12 col-md-4 mb-3'>
                                                                        <div className={`p-3 rounded bg-light border-left border-${field.color} shadow-sm h-100`} style={{ borderLeftWidth: '5px' }}>
                                                                            <small className='text-muted text-uppercase font-weight-bold d-block mb-1' style={html?.labels?.detailMicro}>
                                                                                <i className={`${field.icon} mr-1`} /> {field.label}
                                                                            </small>
                                                                            <span className='text-dark font-weight-bold'>{field.value}</span>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                            <hr className='my-4' />
                                                        </>
                                                    }

                                                </div>

                                                <div className='card-footer bg-white border-0 d-flex flex-wrap justify-content-end align-items-center py-3' style={{ gap: '8px' }}>
                                                    <button id={controls?.buttons?.processDetails?.id}
                                                        ref={btnProcessDetailsRef}
                                                        className={controls?.buttons?.processDetails?.defaultClass}
                                                        hidden
                                                        style={{ borderRadius: '5px' }}
                                                        onClick={(e) => getSystemAccessDetailAddDetailEdit({ e: e, processType: 2014, })}
                                                        title={labels?.process?.[languageObj?.id]}
                                                        type='button'>
                                                        <i id={controls?.icons?.processDetails?.id} className={controls?.icons?.processDetails?.defaultClass} /> {labels?.process?.[languageObj?.id]}
                                                    </button>

                                                    <button id={controls?.buttons?.save?.id}
                                                        className={controls?.buttons?.save?.defaultClass}
                                                        disabled={
                                                            process?.showLoading ||
                                                            (systemAccess?.statusId === statusObj?.finalized?.model?.id &&
                                                                systemAccessBefore?.statusId === statusObj?.finalized?.model?.id)
                                                        }
                                                        hidden={viewParams?.type === 2}
                                                        style={{ borderRadius: '5px' }}
                                                        title={viewParams?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                                        type='submit'>
                                                        {!process?.save ? (
                                                            <i id={controls?.icons?.save?.id} className={controls?.icons?.save?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.save?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {viewParams?.type === 0 ? labels?.add?.[languageObj?.id] : labels?.save?.[languageObj?.id]}
                                                    </button>

                                                    <button id={controls?.buttons?.addDetail?.id}
                                                        className={controls?.buttons?.addDetail?.defaultClass}
                                                        disabled={
                                                            process?.showLoading ||
                                                            (systemAccess?.statusId === statusObj?.finalized?.model?.id &&
                                                                systemAccessBefore?.statusId === statusObj?.finalized?.model?.id) ||
                                                            (!userRoles?.isAnalyst && !userRoles?.isAdmin)
                                                        }
                                                        hidden={viewParams?.type === 0 || viewParams?.type === 2 || (!userRoles?.isAnalyst && !userRoles?.isAdmin)}
                                                        style={{ borderRadius: '5px' }}
                                                        onClick={(e) => getSystemAccessDetailAddDetailEdit({ e: e, processType: 0, subMethod: e.currentTarget?.id, })}
                                                        title={labels?.addDetail?.[languageObj?.id]}
                                                        type='button'>
                                                        {!process?.addDetail ? (
                                                            <i id={controls?.icons?.addDetail?.id} className={controls?.icons?.addDetail?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.addDetail?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.addDetail?.[languageObj?.id]}
                                                    </button>

                                                    <button id={controls?.buttons?.edit?.id}
                                                        className={controls?.buttons?.edit?.defaultClass}
                                                        hidden={viewParams?.type !== 2 || (!userRoles?.isAdmin && !userRoles?.isAnalyst)}
                                                        disabled={process?.showLoading || viewParams?.type !== 2 ||
                                                            (systemAccess?.statusId === statusObj?.finalized?.model?.id &&
                                                                systemAccessBefore?.statusId === statusObj?.finalized?.model?.id)
                                                        }
                                                        style={{ borderRadius: '5px' }}
                                                        title={labels?.edit?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={(e) => goToBack({ e: e, _processType: 1, subMethod: controls?.buttons?.edit?.id })}>
                                                        {!process?.edit ? (
                                                            <i id={controls?.icons?.edit?.id} className={controls?.icons?.edit?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.edit?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.edit?.[languageObj?.id]}
                                                    </button>

                                                    <button id={controls?.buttons?.report?.id}
                                                        className={controls?.buttons?.report?.defaultClass}
                                                        hidden={viewParams?.type !== 2}
                                                        disabled={process?.showLoading || viewParams?.type !== 2}
                                                        style={{ borderRadius: '5px' }}
                                                        title={labels?.report?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={(e) => getReportSystemAccess({ e: e, subMethod: controls?.buttons?.report?.id })}>
                                                        {!process?.report ? (
                                                            <i id={controls?.icons?.report?.id} className={controls?.icons?.report?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.report?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.report?.[languageObj?.id]}
                                                    </button>

                                                    <button id={controls?.buttons?.back?.id}
                                                        className={controls?.buttons?.back?.defaultClass}
                                                        disabled={process?.showLoading}
                                                        style={{ borderRadius: '5px' }}
                                                        title={labels?.close?.[languageObj?.id]}
                                                        type='button'
                                                        onClick={(e) => goToBack({ e: e, _processType: 0, subMethod: controls?.buttons?.back?.id })}>
                                                        {!process?.back ? (
                                                            <i id={controls?.icons?.back?.id} className={controls?.icons?.back?.defaultClass} />
                                                        ) : (
                                                            <span id={controls?.spiners?.back?.id} className={settings?.react?.html?.spinner?.borderSm} aria-hidden='true'></span>
                                                        )} {labels?.back?.[languageObj?.id]}
                                                    </button>
                                                </div>
                                                {/* /.card-body */}
                                            </div>
                                        </form>

                                        {viewParams?.id !== 0 && (
                                            <div className='card shadow-lg border-0' style={{ borderRadius: '15px', overflow: 'hidden' }}>
                                                <LoadingSection alt='loadingSection'
                                                    className='overlay dark text-white'
                                                    height={20}
                                                    hidden={!process?.showLoading}
                                                    width={20}
                                                    languageId={languageObj?.id}
                                                    subMethod={currentMethod} />
                                                <div className='card-header bg-white py-3 border-0 d-flex align-items-center'>
                                                    <div className='bg-light p-1 rounded-circle mr-2 shadow-sm' style={{ width: '28px', height: '28px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <i className={`${icons?.fasFa?.list} text-secondary`} style={{ fontSize: '12px' }}></i>
                                                    </div>
                                                    <h6 className='mb-0 font-weight-bold text-dark'>{labels?.details?.[languageObj?.id]}</h6>
                                                </div>

                                                {/* Section: Backup Reviews */}
                                                <div className='card-body px-4 pb-4'>
                                                    <TableIndex tableId={dtSystemAccessesDetailsId} languageObj={languageObj} />
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                ) : (
                                    <div></div>
                                )}
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}
                    </div>
                </section >

            </div>

            {modalObj?.showModal && (
                <SystemAccessDetailAddEditDetail modalObj={modalObj}
                    setModalObj={setModalObj} />
            )}
        </div>
    )
}